import { faEnvelope, faMobile, faPhone } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Segment } from "semantic-ui-react";
import { GetNotifyContactSubscriberContactMethodsResponse } from "../../../../../../queries/notify";
import { buildIdentifierString } from "../../subscribers/utils/buildIdentifierString";
import { faBan, faEllipsis, faLock, faRotateLeft, faTrashAlt } from "@fortawesome/pro-solid-svg-icons";
import { OptOutSubscriberModal } from "../../subscribers/modals/OptOutSubscriberModal";
import { useState } from "react";
import { OptOutAndDisconnectSubscriberContactMethodModal } from "../../subscribers/modals/OptOutAndDisconnectSubscriberContactMethodModal";
import identitySelectors from "../../../../../../selectors/identity";
import { useNotifySubscriberContactMethodOptIn } from "../../../../hooks/useNotifySubscriberContactMethodOptIn";
import { buildNotifyContactQueryKey } from "../../../../hooks/useNotifyContact";
import { ToastStatuses } from "../../../../../../components/global_components/Toast";
import { useToasts } from "react-toast-notifications";
import { useQueryCache } from "react-query";

const notifyContactMethodTypes = {
  EMAIL: "Email",
  PHONE: "Phone",
  APP: "App",
};
const notifyContactMethodStatuses = {
  OptedOut: "Opted Out",
  Invited: "Invited",
};
export function NotifyContactSubscriberContactMethodRow({
  subscriberContactMethod,
  disabled,
  notifyContactId,
}: {
  subscriberContactMethod: GetNotifyContactSubscriberContactMethodsResponse;
  notifyContactId: number;
  disabled?: boolean;
}) {
  const [isOptOutModalOpen, setIsOptOutModalOpen] = useState(false);
  const [isOptOutAndDisconnectModalOpen, setIsOptOutAndDisconnectModalOpen] = useState(false);
  const username = identitySelectors.getUserUsername();

  const { addToast } = useToasts();
  const queryCache = useQueryCache();

  const { DANGER_optInSubscriberContactMethod } = useNotifySubscriberContactMethodOptIn({
    onSuccess: async () => {
      addToast(`Contact method opted in`, { appearance: ToastStatuses.Success, autoDismiss: true });
      await queryCache.invalidateQueries(buildNotifyContactQueryKey({ id: notifyContactId }));
    },
  });

  const isGovout = username === "govout143";

  const iconLookup: Record<string, Function> = {
    Email: () => <FontAwesomeIcon className={`tw-text-purple ${disabled ? "tw-opacity-50" : ""}`} icon={faEnvelope} />,
    Phone: () => <FontAwesomeIcon className={`tw-text-orange ${disabled ? "tw-opacity-50" : ""}`} icon={faPhone} />,
    App: () => <FontAwesomeIcon className={`tw-text-teal ${disabled ? "tw-opacity-50" : ""}`} icon={faMobile} />,
  };

  return (
    <>
      <OptOutSubscriberModal
        isOpen={isOptOutModalOpen}
        close={() => setIsOptOutModalOpen(false)}
        subscriberContactMethodId={subscriberContactMethod.id}
        notifyContactId={notifyContactId}
      />
      <OptOutAndDisconnectSubscriberContactMethodModal
        isOpen={isOptOutAndDisconnectModalOpen}
        close={() => setIsOptOutAndDisconnectModalOpen(false)}
        subscriberContactMethodId={subscriberContactMethod.id}
        notifyContactId={notifyContactId}
      />

      <Segment key={subscriberContactMethod.id} className='tw-flex tw-items-center tw-justify-between'>
        <div
          className={`tw-tg-title-medium tw-flex tw-items-center tw-gap-3 tw-font-bold ${disabled ? "tw-text-primary-hint" : ""}`}
        >
          {iconLookup[subscriberContactMethod.type] && iconLookup[subscriberContactMethod.type]()}
          <span>
            {buildIdentifierString(subscriberContactMethod)}
            {subscriberContactMethod.isPrimary && " (Primary)"}
          </span>
        </div>
        {/* If they are enrolled, use the clickable dropdown, otherwise use an icon that is not clicable */}
        {subscriberContactMethod.status && (
          <div className='tw-flex tw-items-center tw-gap-2'>
            {subscriberContactMethod.status != "Enrolled" && (
              <span className='tw-tg-label-small tw-text-primary-hint'>
                {notifyContactMethodStatuses[subscriberContactMethod.status]}
              </span>
            )}

            <Dropdown
              item
              trigger={
                <div role='button' tabIndex={0} className='tw-cursor-pointer'>
                  <FontAwesomeIcon icon={faEllipsis} className='tw-text-[24px] tw-text-primary-hint' />
                </div>
              }
              direction='left'
              icon={null}
            >
              <Dropdown.Menu>
                {isGovout && (
                  <Dropdown.Item>
                    <FontAwesomeIcon icon={faLock} className='tw-mr-1 tw-text-red' />
                    Send Test
                  </Dropdown.Item>
                )}
                {subscriberContactMethod.status === "Enrolled" && (
                  <Dropdown.Item onClick={() => setIsOptOutModalOpen((prev) => !prev)}>
                    <FontAwesomeIcon icon={faBan} className='tw-mr-1' />
                    Opt out
                  </Dropdown.Item>
                )}
                {subscriberContactMethod.status === "OptedOut" && (
                  <Dropdown.Item
                    onClick={async () =>
                      await DANGER_optInSubscriberContactMethod({
                        subscriberContactMethodIds: [subscriberContactMethod.id],
                        justification: "User opted in via web portal",
                      })
                    }
                  >
                    <FontAwesomeIcon icon={faRotateLeft} className='tw-mr-1' />
                    Opt In
                  </Dropdown.Item>
                )}
                {!subscriberContactMethod.isPrimary &&
                  subscriberContactMethod.type !== notifyContactMethodTypes.APP && (
                    <Dropdown.Item onClick={() => setIsOptOutAndDisconnectModalOpen((prev) => !prev)}>
                      <FontAwesomeIcon icon={faTrashAlt} className='tw-mr-1' />
                      Remove
                    </Dropdown.Item>
                  )}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
      </Segment>
    </>
  );
}
